import type { NavigationLevel } from '@/app/navigation-context/types.js';

const LEVEL_KEY_PREFIX = 'zr-nav';

function storageKey(userId: string, suffix: string): string {
  return `${LEVEL_KEY_PREFIX}:${userId}:${suffix}`;
}

export interface PersistedNavigationContext {
  level: NavigationLevel;
  placeId: string | null;
  tenantId: string | null;
  networkId: string | null;
}

export function readPersistedNavigationContext(userId: string): PersistedNavigationContext | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const level = window.localStorage.getItem(storageKey(userId, 'level'));
  if (level !== 'place' && level !== 'tenant' && level !== 'network' && level !== 'platform') {
    return null;
  }

  return {
    level,
    placeId: window.localStorage.getItem(storageKey(userId, 'place-id')),
    tenantId: window.localStorage.getItem(storageKey(userId, 'tenant-id')),
    networkId: window.localStorage.getItem(storageKey(userId, 'network-id')),
  };
}

export function writePersistedNavigationContext(
  userId: string,
  context: PersistedNavigationContext,
): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(storageKey(userId, 'level'), context.level);
  setOrRemove(storageKey(userId, 'place-id'), context.placeId);
  setOrRemove(storageKey(userId, 'tenant-id'), context.tenantId);
  setOrRemove(storageKey(userId, 'network-id'), context.networkId);
}

function setOrRemove(key: string, value: string | null): void {
  if (value) {
    window.localStorage.setItem(key, value);
  } else {
    window.localStorage.removeItem(key);
  }
}

export function clearPersistedNavigationContext(userId: string): void {
  if (typeof window === 'undefined') {
    return;
  }

  for (const suffix of ['level', 'place-id', 'tenant-id', 'network-id']) {
    window.localStorage.removeItem(storageKey(userId, suffix));
  }
}
